import {mql} from './global';

/**
 * メディアクエリイベントの登録
 * @return {Void}
 */
export default () => {
    const MATCH_MEDIA_EVENT = 'matchMedia';
    const isMatchMedia = () => {
        const event = document.createEvent('Event');

        mql.state = mql.matches ? 'PC' : 'SP';

        // カスタムイベントの発火
        event.initEvent(MATCH_MEDIA_EVENT, false, true);
        window.dispatchEvent(event);
    };

    mql.event = MATCH_MEDIA_EVENT;
    mql.addListener(isMatchMedia);
    isMatchMedia(); // 初期実行
};
